import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import usersData from "../slices/usersData";
import partyDetailsSlice from "../slices/partyDetailsSlice";
import otpReducer from "../slices/otpSlice";
import AttendanceSlice from "../slices/AttendanceSlice";

const rootReducers = combineReducers({
  auth: authReducer,
  data: usersData,
  partyDetails: partyDetailsSlice,
  otp: otpReducer,
  Attendance: AttendanceSlice,
});

export default rootReducers;
